
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Combobox from '../../../core/components/Generics/Combobox/Combobox.vue';
import { ComboSelectedOption } from '../../../core/components/Generics/Combobox/Combobox';

@Component({
  components: { 
    Combobox
  },
})
export default class ColorQuantitySelector extends Vue {
  @Prop({ default: null }) value!: ComboSelectedOption | null;
  @Prop({ default: 3 }) minValue!: number;
  @Prop({ default: 11 }) maxValue!: number;
  @Prop({ default: null }) customOptions!: number[] | null;

  get scaleOptions() {
    // If custom options are provided, use them
    if (this.customOptions && this.customOptions.length > 0) {
      return this.customOptions.map(num => ({
        id: num,
        value: num.toString()
      }));
    }
    
    // Otherwise, generate odd numbers from 3 to maxValue (default behavior)
    const options: Array<{id: number, value: string}> = [];
    for (let i = 3; i <= this.maxValue; i += 2) {
      options.push({
        id: i,
        value: i.toString()
      });
    }
    return options;
  }

  handleSelection(selectedOption: ComboSelectedOption) {
    this.$emit('input', selectedOption);
  }

  @Emit('open')
  onComboboxOpen() {}

  @Emit('close')
  onComboboxClose() {}

  @Emit('input')
  input(value: ComboSelectedOption) {
    return value;
  }
}
